import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const AppShowModal = ({ show, isLoggedIn, userDetail, onClose }) => {
  if (!show) return null;

  const navigate = useNavigate();

  const [businessStatus, setBusinessStatus] = useState("none");
  // Possible values: "none", "pending", "approved", "rejected"

  const handleRegisterClick = () => {
    navigate("register-your-business");
    setBusinessStatus("pending");
  };

  const handleAdminClick = () => {
    navigate("/company-list");
  };
  const handleEmployeeClick = () => {
    navigate("/dashboard");
  };

  return (
    <div className="app-modal-overlay" onClick={onClose}>
      <div className="app-modal-box" onClick={(e) => e.stopPropagation()}>
        {!isLoggedIn && (
          <div className="app-login-btn">
            <Link
              to="/login"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Login
            </Link>{" "}
            <span className="spss_lst">/</span>{" "}
            <Link
              to="/auth-screen"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Sign up
            </Link>
          </div>
        )}

        {isLoggedIn && (
          <div className="app-loggedin-row">
            <div className="app-user-block">
              <div className="app-user-circle">
                <Link
                  to="/profile"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  {userDetail?.first_name?.charAt(0)?.toUpperCase() || "A"}
                </Link>
              </div>
              <span className="app-user-text">Account</span>
            </div>
            {userDetail?.userTypeLabel === "employee" ? (
              <div className="app-user-block">
                <div className="app-user-circle" onClick={handleEmployeeClick}>
                  A
                </div>
                <span className="app-user-text">Admin</span>
              </div>
            ) : userDetail?.organization?.length === 0 ? (
              <button
                className="app-register-btn"
                onClick={handleRegisterClick}
              >
                Register your business
              </button>
            ) : (
              <div className="app-user-block">
                <div className="app-user-circle" onClick={handleAdminClick}>
                  A
                </div>
                <span className="app-user-text">Admin</span>
              </div>
            )}

            {/* {businessStatus === "none" || businessStatus === "rejected" ? (
              <button
                className="app-register-btn"
                onClick={handleRegisterClick}
              >
                Register your business
              </button>
            ) : (
              <div className="app-user-block">
                <div className="app-user-circle" onClick={handleAdminClick}>
                  A
                </div>
                <span className="app-user-text">Admin</span>
              </div>
            )} */}
          </div>
        )}

        <div className="app-divider"></div>

        <div className="app-icons-row">
          <Link to="/" className="app-item">
            <img
              src="/images/worldtrust.png"
              className="app-icon-img"
              alt="Worldtrust"
            />
            <span>Worldtrust</span>
          </Link>
          <a
            href="https://workdtrustdirectory.allproject.online/"
            target="_blank"
            rel="noopener noreferrer"
            className="app-item"
          >
            <img
              src="/images/directory_icon.png"
              className="app-icon-img"
              alt="Directory"
            />
            <span>Directory</span>
          </a>

          <a
            href="https://worldtrustmall.allproject.online/"
            target="_blank"
            rel="noopener noreferrer"
            className="app-item"
          >
            <img src="/images/mall.png" className="app-icon-img" alt="Mall" />
            <span>Mall</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppShowModal;
